import React, { useEffect, useState, useContext } from "react";
import { PropTypes } from "prop-types";
import { Button, MenuItem, ControlGroup, InputGroup } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import { LangContext } from "../../LangContext";

EditableListField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * List of items to be rendered in the drop down
   */
  items: PropTypes.array,

  /**
   * Field value
   */
  value: PropTypes.string,

  /**
   * Triggered when field value is changed
   */
  onValueChange: PropTypes.func,

  /**
   * Triggered when field validity is changed
   */
  onValidityChange: PropTypes.func,

  /**
   * Set as required. If field is set as required an value is NULL then field will be marked as invalid
   */
  required: PropTypes.bool,

  /**
   * Set to true to disable this field
   */
  disabled: PropTypes.bool
} : {};

export default function EditableListField(props) {
  var lang = useContext(LangContext);

  var value = props.value,
      onValueChange = props.onValueChange,
      onValidityChange = props.onValidityChange,
      required = props.required,
      items = props.items,
      disabled = props.disabled,
      readOnly = props.readOnly,
      displayForm = props.displayForm;

  var _useState = useState(true),
      valid = _useState[0],
      setValid = _useState[1];

  useEffect(function () {
    var invalidRequired = !value && required;

    var isValid = !invalidRequired;
    if (isValid != valid) {
      setValid(isValid);
      onValidityChange && onValidityChange(isValid);
    }
  }, [value, valid, required]);

  var handleChange = function handleChange(clickedValue) {
    onValueChange(clickedValue);
  };

  var handleClear = function handleClear() {
    return onValueChange([]);
  };

  return displayForm ? React.createElement(
    "span",
    { className: "dt-field-value" },
    value
  ) : React.createElement(
    ControlGroup,
    { fill: true },
    readOnly ? React.createElement(InputGroup, { readOnly: true, value: value }) : React.createElement(
      React.Fragment,
      null,
      React.createElement(Suggest, {
        createNewItemFromQuery: function createNewItemFromQuery(i) {
          return i;
        },
        createNewItemRenderer: function createNewItemRenderer(query, active, handleClick) {
          return React.createElement(MenuItem, {
            icon: "add",
            text: lang.create + ("\"" + query + "\""),
            active: active,
            onClick: handleClick,
            shouldDismissPopover: false
          });
        },
        itemPredicate: function itemPredicate(query, item, _index, exactMatch) {
          var normalizedTitle = item.toLowerCase();
          var normalizedQuery = query.toLowerCase();

          if (exactMatch) {
            return normalizedTitle === normalizedQuery;
          } else {
            return item.indexOf(normalizedQuery) >= 0;
          }
        },
        items: items,
        itemRenderer: function itemRenderer(i, _ref) {
          var handleClick = _ref.handleClick;
          return React.createElement(MenuItem, {
            key: i,
            active: value === i,
            onClick: handleClick,
            text: i
          });
        },
        inputValueRenderer: function inputValueRenderer(i) {
          return i;
        },
        noResults: React.createElement(MenuItem, { disabled: true, text: lang.noResults }),
        onItemSelect: handleChange,
        popoverProps: { minimal: true },
        selectedItem: value,
        disabled: disabled
      }),
      value && React.createElement(Button, {
        icon: "cross",
        onClick: handleClear,
        style: { flex: "0 0 30px" },
        disabled: disabled
      })
    )
  );
}